import { memo } from "react";

import { InputError } from "components";

import { typeToIconMap } from "./constants";
import { BasicInputIconPlacement, BasicInputMode } from "./enums";
import {
  StyledBasicInputGridPosition,
  StyledInput,
  StyledInputIconWrapper,
} from "./styles";
import { IBasicInput } from "./types";

const BasicInput: React.FC<IBasicInput> = ({
  label,
  value,
  name,
  onChange,
  errors,
  additionalIconPlacement,
  additionalIconJsx,
  disabled,
  required,
  iconType,
  type = "text",
  mode = BasicInputMode.DEFAULT,
  size = "small",
  variant = "filled",
  noPointerEvent,
  numberValue,
  isViewMode,
  enableIcon,
  inputProps,
  ...props
}: IBasicInput) => {
  const placeholder = required ? `${label}*` : label;
  const pointerEventSelector = enableIcon
    ? ":not(.input-icon-wrapper, .input-icon-wrapper> *)"
    : "";

  return (
    <InputError
      errors={errors}
      wrapperSx={
        noPointerEvent
          ? {
              [`& *${pointerEventSelector}`]: {
                pointerEvents: "none !important",
              },
            }
          : undefined
      }
    >
      <StyledBasicInputGridPosition container>
        {iconType && (
          <StyledInputIconWrapper>
            {typeToIconMap[iconType]()}
          </StyledInputIconWrapper>
        )}
        {additionalIconPlacement && additionalIconJsx && (
          <StyledInputIconWrapper
            className="input-icon-wrapper"
            isEndPlacement={
              additionalIconPlacement === BasicInputIconPlacement.END
            }
          >
            {additionalIconJsx()}
          </StyledInputIconWrapper>
        )}
        <StyledInput
          placeholder={variant === "outlined" ? placeholder : undefined}
          label={variant === "filled" ? placeholder : undefined}
          fullWidth
          variant={variant}
          size={size}
          type={type}
          name={name}
          disabled={isViewMode || disabled}
          value={value}
          onChange={
            numberValue
              ? (
                  e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
                ) => {
                  e.target.value = e.target.value.replace(/[^.,\d]/g, "");

                  return onChange(e);
                }
              : onChange
          }
          mode={mode}
          additionalIconPlacement={additionalIconPlacement}
          iconType={iconType}
          InputProps={inputProps}
          {...props}
        />
      </StyledBasicInputGridPosition>
    </InputError>
  );
};

export default memo(BasicInput);
